import { render, staticRenderFns } from "./FormCheck.vue?vue&type=template&id=2bfa6dfa&"
import script from "./FormCheck.vue?vue&type=script&lang=js&"
export * from "./FormCheck.vue?vue&type=script&lang=js&"
import style0 from "./FormCheck.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports